import { render } from "./TypographyView.vue?vue&type=template&id=3af5eed1&scoped=true"
import script from "./TypographyView.vue?vue&type=script&lang=js"
export * from "./TypographyView.vue?vue&type=script&lang=js"

import "./TypographyView.vue?vue&type=style&index=0&id=3af5eed1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af5eed1"]])

export default __exports__